<template>
  <div class="checkout-summary summary-list">
    <div class="summary-item">
      <div v-apply-theme :class="'valor-total'">
        Valor total
      </div>
      <div v-apply-theme :class="[
        'valor-total__valor',
        { skeleton: loading && moneyFilter(totalAmount) }
      ]">
        {{ moneyFilter(totalAmount) || '-' }}
      </div>
    </div>
    <div class="summary-footer-info" v-if="cetPA && interestRatePM">
      <div :class="['d-flex', { skeleton: loading }]">
        <div class="summary-footer-info-content">
          {{ maxCetText }}
        </div>
        <div class="summary-footer-info-content">
          {{ interestText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import { ApplyTheme } from '@/directives/applyTheme';

export default {
  name: 'checkout-summary-short',
  mixins: [StringMixin],
  directives: {
    ApplyTheme,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    totalAmount: {
      type: Number,
    },
    interestRatePM: {
      type: Number,
    },
    cetPA: {
      type: Number,
    },
  },
  computed: {
    interestText() {
      return `Juros de ${this.interestRateFilter(this.interestRatePM)} a.m. + encargos.`;
    },
    maxCetText() {
      return `CET máximo de ${this.interestRateFilter(this.cetPA)} a.a.`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/styles/helpers.scss';

.summary-list {
  background-color: var(--gray-100);
  border-radius: 4px;
}

.summary-item {
  padding: 12px 12px 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.summary-footer-info {
  display: flex;
  justify-content: flex-end;
  padding: 0 12px 12px;
  font-size: 10px;
  line-height: 16px;
  @extend .gray-500;
}

.summary-footer-info-content:first-child {
  margin-bottom: 4px;
  margin-right: 4px;
}

.valor-total {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;

  &--vivo {
    font-weight: 200 !important;
    letter-spacing: -0.5px;
  }

  &__valor {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;

    &--vivo {
      letter-spacing: -0.5px;
    }
  }
}

</style>
